// app/javascript/src/Search.js

class UISearch {
  constructor(el) {
    if (!el) {
      console.error("UISearch: Search element not provided.");
      return;
    }
    this.el = el;
    this.inputEl = this.el.querySelector("input.sb-search-input");
    if (!this.inputEl) {
      console.error(
        "UISearch: Input element (.sb-search-input) not found within:",
        el
      );
      return;
    }
    this.isOpen = false;
    this.bodyClickHandler = this._handleBodyClick.bind(this); // Bind for later removal

    this._initEvents();
  }

  _initEvents() {
    const initSearchFn = (ev) => {
      // Prevent default action only if closing an empty search
      if (
        this.el.classList.contains("sb-search-open") &&
        this.inputEl.value.trim() === ""
      ) {
        ev.preventDefault();
        this.close(); // Close if empty
      }
      // Don't stop propagation here unless necessary, let body click handle closing
    };

    // Listener for main search element click/touch
    this.el.addEventListener("click", initSearchFn);
    this.el.addEventListener("touchstart", initSearchFn);

    // Stop propagation on input click/touch to prevent immediate closing
    this.inputEl.addEventListener("click", (ev) => ev.stopPropagation());
    this.inputEl.addEventListener("touchstart", (ev) => ev.stopPropagation());
  }

  open() {
    if (this.isOpen) return; // Prevent multiple opens/listener attachments

    const isLikelyMobile = window.innerWidth < 768;

    // On mobile the search lives inside the slid-down menu and is already
    // displayed inline — no expand-over-nav behavior, and we must NOT hide
    // the .nav-card siblings (that would collapse the menu visually).
    if (!isLikelyMobile) {
      document.querySelectorAll(".nav-card").forEach((card) => {
        card.style.display = "none";
      });

      this.el.classList.add("sb-search-open");

      setTimeout(() => this.inputEl.focus(), 50);

      // Outside-click to close — desktop only. On mobile the user has the
      // burger to close the whole menu.
      setTimeout(() => {
        document.addEventListener("click", this.bodyClickHandler);
        document.addEventListener("touchstart", this.bodyClickHandler);
      }, 0);
    } else {
      this.inputEl.focus();
    }

    this.isOpen = true;
  }

  close() {
    const isLikelyMobile = window.innerWidth < 768;

    if (!isLikelyMobile) {
      setTimeout(() => {
        document.querySelectorAll(".nav-card").forEach((card) => {
          card.style.display = "";
        });
      }, 400);

      this.el.classList.remove("sb-search-open");

      document.removeEventListener("click", this.bodyClickHandler);
      document.removeEventListener("touchstart", this.bodyClickHandler);
    }

    this.inputEl.blur();
    this.isOpen = false;
  }

  // Bound function to handle body clicks for closing
  _handleBodyClick(ev) {
    // Only close if the click is outside the search element itself
    if (!this.el.contains(ev.target)) {
      this.close();
    }
  }
}

// Initialization logic, run on turbolinks:load
function initializeSearch() {
  console.log("Initializing search component...");
  const searchElement = document.getElementById("sb-search");
  const openButton = document.getElementById("opensearch");
  const closeButton = document.getElementById("closesearch");

  if (searchElement) {
    const searchInstance = new UISearch(searchElement);

    if (openButton) {
      openButton.addEventListener("click", (e) => {
        e.preventDefault(); // Prevent link navigation
        e.stopPropagation(); // Prevent body click handler closing immediately
        searchInstance.open();
      });
    } else {
      console.warn("Open search button (#opensearch) not found.");
    }

    if (closeButton) {
      closeButton.addEventListener("click", (e) => {
        e.preventDefault(); // Prevent link navigation
        e.stopPropagation(); // Prevent body click handler closing immediately
        searchInstance.close();
      });
    } else {
      console.warn("Close search button (#closesearch) not found.");
    }
  } else {
    console.warn("Search element (#sb-search) not found.");
  }
}

document.addEventListener("turbolinks:load", initializeSearch);

// Note: No need to export UISearch unless other modules need to instantiate it.
// The initialization runs automatically when this module is imported.
